<template>
    <div class="UserAgreement xi">
        <nh-com></nh-com>
        <div class="banner">
            <div class="banner-text">
                <h3>互联网风险告知书</h3>
                <!-- <p>Ge Ren XI YI</p> -->
            </div>
        </div>
        <div class="agreement-box">
            <div class="agreement-tit">
                <h3>互联网风险告知书</h3>
            </div>
            <div class="agreement-content">
                 <div class="disclaimer-container">
                        <div class="disclaimer-content">
                        <p>根据互联网相关的法律法规的要求，请患者务必阅读、知晓互联网相关的执业规则，并接受《互联网风险告知书》。</p>
                        <p>医生向患者提供互联网预约、问诊、诊疗等服务时，医生应当掌握您或患者病历资料，待确定患者的诊断后，针对相应的诊断进行诊断并开具处方。</p>
                        <p>互联网医生不能开具麻醉药品、精神类等药品，同时也不能开具用药风险较高或有其他特殊管理规定的药品处方。</p>
                        <p>互联网医生在为6岁以下的儿童，或者18岁以下未成年患者开具用药处方时，应当有父母、监护人或相关专业医师陪同，并取得父母、监护人或陪同医师的确认。</p>
                        <p>互联网医院不能直接进行体格检查和实施检查、检验等诊查手段，一旦医生认为患者出现病情变化且需要医务人员亲自诊查时，或复诊疾病属于疑难杂症、出现急症等情形时，医生有权终止本次互联网诊疗活动，患者应积极配合到实体医疗机构就诊。</p>
                        <p>患者应遵守相关的服务流程和约定。患者应妥善保管信息，不得非法买卖和泄露信息并在发现信息泄露时，积极上报。</p>
                        <p>互联网诊疗具有很大的局限性，比如医生不能面诊、触诊等情况，主要依赖于患者上传的资料，比如患者填写的内容、上传的图文、视频以及既往的病历资料、临床诊断等。如果患者提供的信息不准确或者不全面，那对于最后的诊疗方案会产生一定的影响。</p>
                        <p>互联网医生皆来自于不同的医院，但受限于医生的职称级别、业务水平、工作年限、工作经验等方面，患者可根据需要，自行选择医生，最后的诊疗方案可能存在一定的差异。</p>
                        <p>由于疾病本身的特殊性和复杂性，患者本身的体质状况，及现有医疗水平条件的限制等，都存在可能发生各种并发症和危害自身生命健康的意外风险。</p>
                        <p>由于疾病本身的复杂性，以及诊疗措施疗效出现的延后性，诊疗方案、健康管理方案、远程医疗方案可能不会达到患者期许的效果，且有些疾病或并发症是不可根治的，需要患者积极配合，长期坚持治疗，才能延缓疾病的进展。医生已经尽力为患者制定合理的方案，致力减少药物治疗不良反应的发生，但不可能完全避免，且不可预测，需要在患者的配合下，并根据临床情况不断调整方案。</p>
                        <p>疾病的治愈需要患者谨遵医嘱、健康管理方案，并积极配合。如果患者未完全遵守和配合，则可能导致诊疗效果不理想，甚至出现病情反复、恶化等不良后果。</p>
                        <p>配送药品可能受到物流时效的影响，导致患者延时服用药物，或患者正在用药物或者手术等治疗其他疾病，也可能存在延时用药、联合用药等风险。</p>
                        <p>患者自采药品的品牌、规格、性状、使用方式等可能影响本次诊疗方案的效果，同时还可能出现危害生命健康的风险。</p>
                        <p>为确保互联网服务全程可监管、可跟踪，所有的提交资料、问诊记录、聊天内容或录音录像等内容，都会留存，并备份，以确保数据不会丢失。</p>
                        <p>以上内容，请患者务必确认、知晓并同意，理解相关的风险，愿意接受互联网服务，如果继续使用相应功能，平台默认为患者同意并已签署《互联网风险告知书》。</p>
                        <div class="footer-space"></div>
                        </div>
                    </div>
            </div>
        </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>
    import ftCom from '../../components/footer';
    import nhCom from "../../components/navheader";
    // import rtBar from "../../components/right";
    export default {
        name: "UserAgreement",
        components: {
            ftCom,
            nhCom,
            // rtBar
        },
    }
</script>

<style scoped>
    .UserAgreement{
        background: #f4f4f4;
    }
    .xi .banner{
        height: 116px;
        background: url("../../assets/img/jbk_banner.png")center no-repeat;
    }
    .banner-text{
        width: 1200px;
        margin: 0 auto;
    }
    .banner-text h3{
        padding-top: 25px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }
    .banner-text p{
        font-size: 18px;
        color: #ffffff;
    }
    .agreement-box {
        margin: 30px auto;
        width: 1200px;
        padding: 20px;
        box-sizing: border-box;
        background: #FFFFFF;
        border: 1px solid #e5e5e5;
    }
    .agreement-tit{
        padding: 10px 0 20px;
        border-bottom: 1px solid #e5e5e5;
    }
    .agreement-tit h3{
        font-size: 20px;
        color: #333333;
        text-align: center;
        font-weight: bold;
    }
    .agreement-content{
        padding: 25px 0;
    }
    .agreement-content p{
        text-indent: 28px;
        line-height: 2;
    }
    .agreement-content p.s-p{
        text-indent: 42px;
    }
    .agreement-content h4{
        text-indent: 28px;
        line-height: 1.7;
        padding: 15px 0;
    }
    .disclaimer-container {
  /* background-color: #f5f5f5; */
  min-height: 100vh;
  padding: 20px 0;
}

.disclaimer-content {
  background-color: #fff;
  padding: 24px;
  margin: 0 auto;
  /* max-width: 800px; */
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  border-radius: 8px;
  color: #666;
  /* line-height: 1.6; */
}

.disclaimer-content p {
  margin: 12px 0;
  text-indent: 2em;
  text-align: justify;
}

.title {
  font-weight: 800;
  padding: 20px 0 10px 0;
  color: #333;
  border-bottom: 1px solid #eee;
  margin: 24px 0 16px 0;
}

.footer-space {
  width: 100%;
  height: 50px;
}
</style>

